import { EQUIPMENT_CATALOGS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/equipment_catalogs_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator([
	'EQUIPMENT_CATALOGS_FOR_EQUIPMENT',
	'equipmentsCatalogDropdown',
	'VENDOR_ASSOCIATED_EQUIPMENTS_TARGET_COLLECTION',
	'add_in_pr_index',
]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
